import React from 'react';
import ContactHeader from '../components/ContactHeader';
import ContactInfo from '../components/ContactInfo';
import ContactForm from '../components/ContactForm';
import LocationMap from '../components/LocationMap';

const Contact: React.FC = () => {
  return (
    <div className="pt-20">
      {/* <ContactHeader /> */}
      <ContactInfo />
      <LocationMap />
      <ContactForm />
    </div>
  );
};

export default Contact; 